import { render, staticRenderFns } from "./TaxInvoiceTcmComponent.vue?vue&type=template&id=2b8e301e&scoped=true&"
import script from "./TaxInvoiceTcmComponent.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceTcmComponent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=2b8e301e&scoped=true&lang=css&"
import style1 from "./TaxInvoiceTcmComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e301e",
  null
  
)

export default component.exports